import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { VideoLessonItem } from "../../../Pages/UserVideoLessonDetail/ILessonsList";

// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = any;

export const DeleteDiscussionVideoLessonsSlice = createSlice({
  name: "DeleteDiscussionVideoLessonsSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    DeleteDiscussionVideoLessons: (state, action) => {
      state.isLoading = true;
    },

    successDeleteDiscussionVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureDeleteDiscussionVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  DeleteDiscussionVideoLessons,
  successDeleteDiscussionVideoLessons,
  failureDeleteDiscussionVideoLessons,
} = DeleteDiscussionVideoLessonsSlice.actions;

export default DeleteDiscussionVideoLessonsSlice.reducer;
